/*
    Create By Chenchen 2015-10-19
*/
'use strict';
angular.module('gUserManageMentModule', ['userManageMentServiceModule', 'userManaShowUserRoleModule', 'trsPasswordStrongModule'])
    .controller('gUserManageMentController', ['$scope', '$timeout', '$q', '$stateParams', '$location', '$state', '$window', 'treeService', 'trsHttpService', 'modalDialog', 'trsspliceString', 'userManageMentService', 'trsTransferService', 'trsGroupTreeLocationService', 'groupUserRightsService', 'localStorageService', 'permissionService',
        function ($scope, $timeout, $q, $stateParams, $location, $state, $window, treeService, trsHttpService, modalDialog, trsspliceString, userManageMentService, trsTransferService, trsGroupTreeLocationService, groupUserRightsService, localStorageService, permissionService) {
            initStatus();
            initData();

            /**
             * [initStatus description]
             *
             * @return  {[type]}  [return description]
             */
            function initStatus() {
                $scope.status = {
                    batchOperateBtn: {
                        'hoverStatus': '',
                        'clickStatus': ''
                    },
                    searchGroup: '',
                    // comparator: false,
                    // isUserNameSearch: false,
                    dragStartIndex: '',
                    btnRights: [],
                    testStatus: $location.path().split('/')[3]
                };
                // $scope.selectedNode = [];
                $scope.data = {
                    selectedArray: [], // 已选
                    keywords: '',
                    copyCurrPage: 1,
                    parentGroupid: $stateParams.groupid ? $stateParams.groupid : null,
                    initStatus: $stateParams.status ? $stateParams.status : null,
                    currStatus: $stateParams.status ? $stateParams.status : null,
                    currGroup: {},
                    totalCounts: 0
                    // userGroupId: localStorageService.get("mlfCachedUser").GroupId,
                };
                // 初始化用户状态
                $scope.userStatus = {
                    30: '已开通',
                    20: '已停用',
                    10: '已删除'
                };
                $scope.page = {
                    'CURRPAGE': 1,
                    'PAGESIZE': 20,
                    'ITEMCOUNT': 0
                };
                $scope.rightsClassify = {
                    30: 'user.open',
                    20: 'user.disable',
                    10: 'user.delete',
                    0: 'user',
                };
                permissionService.isAdministrator().then(function (data) {
                    $scope.status.isAdministrator = data; // 是否是系统管理员
                });
                permissionService.isTenantAdministrator().then(function (data) {
                    $scope.status.isTenantAdministrator = data; // 是否是租户管理员
                });

                /* 用户管理 下拉*/
                $scope.status.statusList = [
                    { name: '所有用户', value: 0 },
                    { name: '已开通', value: 30 },
                    { name: '已停用', value: 20 },
                    // { name: '已删除', value: 10 },
                    { name: '未分配' }
                ];
                $scope.testStatus = $location.search().status;
                for (var i = 0; i < $scope.status.statusList.length; i++) {
                    if ($scope.status.statusList[i].value == $scope.testStatus) {
                        $scope.status.selectedStatus = $scope.status.statusList[i];
                    }
                }
            }

            /**
             * [initData description]初始化数据
             *
             * @return  {[type]}   [return description]
             */
            function initData() {
                initDropDown();
                treeService.queryGroupTreeWithSecondRight().then(function (data) {
                    //! !$scope.data.parentGroupid ? $scope.data.parentGroupid = $scope.data.parentGroupid : $scope.data.parentGroupid = data.GROUPID;
                    // requestData();
                    /* var modalInstance = requestData();
                    modalInstance.then(function() {
                        $scope.data.totalCounts = angular.copy($scope.page.ITEMCOUNT);
                        console.log($scope.data.totalCounts + "====" + $scope.page.ITEMCOUNT);
                    }, function() {});*/
                    requestData().then(function () {
                        $scope.data.totalCounts = angular.copy($scope.page.ITEMCOUNT);
                    });

                    /* getUsersList().then(function() {
                    $scope.data.totalCounts = angular.copy($scope.page.ITEMCOUNT);
                });*/
                    if (angular.isDefined($stateParams.groupid)) { // 有组织id时，获取组织信息(组织名称)
                        queryGroupByGroupId();
                        // 获得用户权限
                        groupUserRightsService.initBtnRights('config.user', $stateParams.groupid).then(function (data) {
                            $scope.status.btnRights = data;
                        });
                    } else {
                        var params = angular.isDefined($stateParams.status) ? $scope.rightsClassify[$stateParams.status] : 'user.undistributed';
                        groupUserRightsService.initGeneralBtnRights(params, '用户管理').then(function (data) {
                            $scope.status.btnRights = data;
                        });
                    }
                });
            }

            /**
             * [newUser description]新建用户
             *
             * @return  {[type]}   [return description]
             */
            $scope.newUser = function () {
                userManageMentService.createUser('', 'userInfo').then(function (data) {
                    requestData().then(function () {
                        $scope.data.totalCounts = angular.copy($scope.page.ITEMCOUNT);
                    });
                }, function (data) {
                    // 失败
                });
            };

            /**
             * [editUser description]编辑用户
             *
             * @param  {[type]}  item   [item description]
             * @param  {[type]}  type   [type description]
             *
             * @return  {[type]}   [return description]
             */
            $scope.editUser = function (item, type) {
                userManageMentService.editUser(item.USERID, type).then(function (data) {
                    requestData();
                }, function (data) {
                    // 失败
                });
            };

            /**
             * [addUsers description]添加用户
             *
             * @return  {[type]}   [return description]
             */
            $scope.addUsers = function () {
                trsTransferService.getUser(function (data) {
                    var params = {
                        'serviceid': 'mlf_groupmanagement',
                        'methodname': 'addUsersToGroup',
                        'UserIds': trsspliceString.spliceString(data, 'ID', ','),
                        'GroupId': $scope.data.parentGroupid

                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                        modalDialog.alertType('添加用户成功', '', 'success', false, function () {
                            requestData().then(function () {
                                $scope.data.totalCounts = angular.copy($scope.page.ITEMCOUNT);
                            });
                        });
                    });
                });
            };

            /**
             * [removeUsers description]移除用户
             *
             * @return  {[type]}   [return description]
             */
            $scope.removeUsers = function () {
                var alertContent = '确认移除当前选中的用户';
                modalDialog.confirmModal('移除用户', alertContent, function () {
                    var params = {
                        serviceid: 'mlf_groupmanagement',
                        methodname: 'removeGroupUsers',
                        GroupId: $scope.data.parentGroupid,
                        UserIds: trsspliceString.spliceString($scope.data.selectedArray, 'USERID', ',')
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                        modalDialog.alertType('移除用户成功', '', 'success', false, function () {
                            requestData().then(function () {
                                $scope.data.totalCounts = angular.copy($scope.page.ITEMCOUNT);
                            });
                        });
                    }, function () {
                        requestData().then(function () {
                            $scope.data.totalCounts = angular.copy($scope.page.ITEMCOUNT);
                        });
                    });
                });
            };

            /**
             * [userMap description]用户映射
             *
             * @param  {[type]}  item   [item description]
             *
             * @return  {[type]}   [return description]
             */
            $scope.userMap = function (item) {
                userManageMentService.userMapping('用户映射', function (data) {
                    $scope.loadingPromise = requestData();
                });
            };

            /**
             * [queryGroupByGroupId description]根据groupid获取组织信息
             *
             * @return  {[type]}   [return description]
             */
            function queryGroupByGroupId() {
                var params = {
                    'serviceid': 'mlf_groupmanagement',
                    'methodname': 'getGroupDetail',
                    'GroupId': $stateParams.groupid
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    $scope.data.currGroup = data;
                });
            }

            /**
             * [initDropDown description]初始化下拉菜单
             *
             * @return  {[type]}   [return description]
             */
            function initDropDown() {

                /* 左侧组织导航树：检索*/
                /* $scope.status.searchOptions = [{
                name: "用户",
                value: "user"
            }];
            $scope.status.searchSelected = angular.copy($scope.status.searchOptions[0]);
            */
                /* 筛选（状态）：检索*/
                $scope.status.searchStatusOptions = [{
                    name: '全部状态',
                    value: null
                }, {
                    name: '已开通',
                    value: 30
                }, {
                    name: '已停用',
                    value: 20
                }
                //     , {
                //     name: '已删除',
                //     value: 10
                    // }
                ];
                initUserStatusSelected();


            }

            /**
             * [godifferenceStatusUser description]前往不同状态的用户管理
             *
             * @param  {[type]}  status   [status description]
             *
             * @return  {[type]}   [return description]
             */
            function godifferenceStatusUser(status) {
                // $timeout(function() {
                //     $scope.status.currStatus = status;
                //     delete $scope.status.selectedNode;

                //     var selectedStatusValue = $scope.status.userStatus[$scope.status.currStatus];
                $state.go('manageconfig.groupmanage.user', { 'status': status, 'groupid': null }, { reload: 'manageconfig.groupmanage.user' });
                // });
            }

            /**
             * [selectFilterType description]用户管理 下拉
             *
             * @return  {[type]}   [return description]
             */
            $scope.selectFilterType = function () {
                var selectedStatusValue = $scope.status.selectedStatus.value;
                godifferenceStatusUser(selectedStatusValue);
            };

            $scope.moveToOhterTenant = function() {
                if ($scope.data.selectedArray.length > 1) {
                    modalDialog.alertType('', '一次只能迁移一个用户', 'error', false);
                    return;
                }
                userManageMentService.moveUser('', trsspliceString.spliceString($scope.data.selectedArray, 'USERID', ','), 'toTenant').then(function (data) {
                    requestData();
                });
            };

            /**
             * [initUserStatusSelected description]初始化下拉框选中"已开通",未分配置空
             *
             * @return  {[type]}   [return description]
             */
            function initUserStatusSelected() {
                $scope.status.searchStatusSelected = angular.copy($scope.status.searchStatusOptions[0]);
                // $scope.status.searchStatusSelected.value = angular.isDefined($stateParams.status) ? $stateParams.status : null;
            }

            /**
         * [queryByDropdown description] 筛选条件触发后请求数据
         * @param  {[type]} key   [description] 请求对象参数key
         * @param  {[type]} selected [description] 请求对象值
         * @return {[type]}       [description] null
         */
            $scope.queryByDropdown = function (key, selected) {
                $scope.testStatus = selected.value;
                var params = {
                    serviceid: 'mlf_usermanagement',
                    methodname: 'searchGroupUsers',
                    GroupId: $scope.data.parentGroupid,
                    Status: selected.value
                };
                $scope.data.keywords = '';
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    $scope.users = data.DATA;
                    $scope.page = data.PAGER;
                    $scope.data.totalCounts = angular.copy($scope.page.ITEMCOUNT);
                    if ($scope.users.length > 0) {
                        timeStamp();
                        // getRolesToString();
                    }
                });
            };

            // 下一页
            $scope.pageChanged = function () {
                // $scope.params.CurrPage = $scope.page.CURRPAGE;
                $scope.data.copyCurrPage = $scope.page.CURRPAGE;
                requestData();
            };

            // 跳转指定页面
            $scope.jumpToPage = function () {
                if ($scope.data.copyCurrPage > $scope.page.PAGECOUNT) {
                    $scope.data.copyCurrPage = $scope.page.PAGECOUNT;
                }
                $scope.page.CURRPAGE = $scope.data.copyCurrPage;
                requestData();
            };

            /**
         * [selectPageNum description]单页选择分页个数
         * @return {[type]} [description]
         */
            $scope.selectPageNum = function () {
                $scope.data.copyCurrPage = 1;
                requestData();
            };

            /**
             * [requestData description]数据请求方法：根据当前组织获取用户列表信息
             *
             * @return  {[type]}   [return description]
             */
            function requestData() {
                var defer = $q.defer();
                var params = {
                    'serviceid': 'mlf_usermanagement',
                    'PageSize': $scope.page.PAGESIZE,
                    'CurrPage': $scope.page.CURRPAGE,
                    'TrueName': $scope.data.keywords
                };
                // params.Status = $location.search().status ? $location.search().status : $scope.status.searchStatusSelected.value;
                params.Status = $scope.testStatus ? $scope.testStatus : $scope.status.searchStatusSelected.value;
                if ($scope.data.parentGroupid != null) {
                    params.GroupId = $scope.data.parentGroupid;
                    if (params.Status == 10) { // 当前组织已删除用户列表
                        params.methodname = 'getGroupDelUsers';
                    } else if (params.Status == 20) { // 当前组织已停用用户列表
                        params.methodname = 'getGroupStoppedUsers';
                    } else if (params.Status == 30) { // 当前组织已开通用户列表
                        params.methodname = 'getGroupHasClearedUsers';
                    } else {
                        params.methodname = 'searchGroupUsers';
                    }
                } else {
                    if (params.Status == 10) { // 用户管理：已删除用户列表
                        params.methodname = 'getDelUsers';
                    } else if (params.Status == 20) { // 用户管理：已停用用户列表
                        params.methodname = 'getStoppedUsers';
                    } else if (params.Status == 30) { // 用户管理：已开通用户列表
                        params.methodname = 'getHasClearedUsers';
                    } else if (params.Status == 0) { // 用户管理：所有用户列表
                        params.methodname = 'queryAllUsers';
                    } else { // 未分配的用户
                        params.methodname = 'getForAllocationUsers';
                    }
                }
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    !!data.PAGER ? $scope.page = data.PAGER : $scope.page.ITEMCOUNT = '0';
                    $scope.page.CURRPAGE = Math.abs($scope.page.CURRPAGE); // 应对后端返回分页存在问题的情况
                    $scope.users = data.DATA;
                    // initUserStatusSelected();
                    $scope.data.selectedArray = [];
                    if ($scope.users.length > 0) {
                        timeStamp();
                        // getRolesToString();
                    }
                    defer.resolve();
                });
                return defer.promise;
            }

            /**
         * [getRolesToString description获取所属角色信息，用逗号分隔]
         * @return {[type]} [description]
         */
            /* function getRolesToString() {
            angular.forEach($scope.users, function(data, index) {
                var rolesArr = [];
                for (var i = 0; i < data.USERROLES.length; i++) {
                    rolesArr[i] = data.USERROLES[i].ROLENAME;
                }
                data.USERROLES = rolesArr.join(",");
            });
        }*/
            /**
             * [timeStamp description]将日期字符串转换为时间戳
             *
             * @return  {[type]}   [return description]
             */
            function timeStamp() {
                angular.forEach($scope.users, function (data, index) {
                    if (data.CRTIME != '') {
                        data.CRTIME = new Date(Date.parse(data.CRTIME.replace(/-/g, '/'))).getTime();
                    }
                    if (data.REGTIME != '') {
                        data.REGTIME = new Date(Date.parse(data.REGTIME.replace(/-/g, '/'))).getTime();
                    }
                });
            }

            /**
             * [determineUserSelected description]判断是否有选中稿件
             *
             * @return  {[type]}   [return description]
             */
            function determineUserSelected() {
                if (!$scope.data.selectedArray.length) {
                    modalDialog.alertType('请先选择用户！', '', 'error', false, '');
                    return false;
                } else {
                    return true;
                }
            }

            /**
             * [deleteUsers description]批量（单个）删除用户
             *
             * @return  {[type]}   [return description]
             */
            $scope.deleteUsers = function () {
                var alertContent = '确认删除?';

                modalDialog.alertType(alertContent, '', 'ask', true, function () {
                    var params = {
                        serviceid: 'mlf_usermanagement',
                        methodname: 'noAssignedDeleteUsers', // 未分配批量删除用户
                        UserIds: trsspliceString.spliceString($scope.data.selectedArray, 'USERID', ',')
                    };

                    // 已开通批量删除用户
                    if ($scope.data.currStatus != null) {
                        params.methodname = 'clearcDeleteUsers';
                    }

                    // 删除组织中的用户
                    if ($scope.data.parentGroupid != null) {
                        params.methodname = 'deleteGroupUsers';
                        params.GroupId = $scope.data.parentGroupid;
                    }

                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                        modalDialog.alertType('删除用户成功', '', 'success', false, function () {
                            requestData().then(function () {
                                $scope.data.totalCounts = angular.copy($scope.page.ITEMCOUNT);
                            });
                        });
                    }, function () {
                        requestData().then(function () {
                            $scope.data.totalCounts = angular.copy($scope.page.ITEMCOUNT);
                        });
                    });
                });
            };

            /**
             * [selectAll description]全选
             *
             * @return  {[type]}   [return description]
             */
            $scope.selectAll = function () {
                $scope.data.selectedArray = $scope.data.selectedArray.length == $scope.users.length ? [] : [].concat($scope.users);
                cancelBatchOperate();
            };

            /**
             * [selectDoc description]单选
             *
             * @param  {[type]}  item   [item description]单个对象
             *
             * @return  {[type]}   [return description]
             */
            $scope.selectDoc = function (item) {
                if ($scope.data.selectedArray.indexOf(item) < 0) {
                    $scope.data.selectedArray.push(item);
                } else {
                    $scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(item), 1);
                }
                cancelBatchOperate();
            };

            /**
             * [cancelBatchOperate description]取消批量操作的样式
             *
             * @return  {[type]}   [return description]
             */
            function cancelBatchOperate() {
                if ($scope.data.selectedArray.length === 0) {
                    $scope.status.batchOperateBtn = {
                        'hoverStatus': '',
                        'clickStatus': ''
                    };
                }
            }

            /**
             * [resetPassword description]重置密码
             *
             * @return  {[type]}   [return description]
             */
            $scope.resetPassword = function () {
                userManageMentService.resetPwd('重置密码', trsspliceString.spliceString($scope.data.selectedArray, 'USERID', ','), /* $scope.data.parentGroupid,*/ function (data) {
                    $scope.loadingPromise = requestData();
                });
            };

            /**
             * [moveUser description]移动用户
             *
             * @return  {[type]}   [return description]
             */
            $scope.moveUser = function () {
                userManageMentService.moveUser($scope.data.parentGroupid, trsspliceString.spliceString($scope.data.selectedArray, 'USERID', ','), 'move').then(function (data) {

                    requestData().then(function () {
                        $scope.data.totalCounts = angular.copy($scope.page.ITEMCOUNT);
                    });
                }, function (data) {

                });
            };

            /**
             * [addUsersToGroup description]（未分配用户）添加到组织
             *
             * @return  {[type]}   [return description]
             */
            $scope.addUsersToGroup = function () {
                userManageMentService.moveUser('', trsspliceString.spliceString($scope.data.selectedArray, 'USERID', ','), 'add').then(function (data) {
                    requestData();
                }, function (data) {

                });
            };

            /**
             * [disableUser description]停用用户
             *
             * @return  {[type]}   [return description]
             */
            $scope.disableUser = function () {
                var alertContent = '确定停用？';
                modalDialog.confirmModal('停用用户', alertContent, function () {
                    var params = {
                        serviceid: 'mlf_usermanagement',
                        methodname: 'noAssignedDisable', // 未分配停用用户
                        UserIds: trsspliceString.spliceString($scope.data.selectedArray, 'USERID', ',')
                    };
                    // 已开通停用用户
                    if ($scope.data.currStatus != null) {
                        params.methodname = 'clearcDisable';
                    }
                    // 停用组织用户
                    if ($scope.data.parentGroupid != null) {
                        params.methodname = 'disableGroupUser';
                        params.GroupId = $scope.data.parentGroupid;
                    }

                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                        modalDialog.alertType('停用用户成功', '', 'success', false, function () {
                            requestData().then(function () {
                                $scope.data.totalCounts = angular.copy($scope.page.ITEMCOUNT);
                            });
                        });
                    }, function () {
                        requestData().then(function () {
                            $scope.data.totalCounts = angular.copy($scope.page.ITEMCOUNT);
                        });
                    });
                });
            };

            /**
             * [reStartUser description]启用用户
             *
             * @return  {[type]}   [return description]
             */
            $scope.reStartUser = function () {
                var alertContent = '确定启用?';

                modalDialog.confirmModal('启用用户', alertContent, function () {
                    var params = {
                        serviceid: 'mlf_usermanagement',
                        methodname: 'noAssignedEnable', // 未分配启用用户
                        UserIds: trsspliceString.spliceString($scope.data.selectedArray, 'USERID', ',')
                    };
                    // 已停用启用用户
                    if ($scope.data.currStatus != null) {
                        params.methodname = 'clearcEnable';
                    }
                    // 启用组织用户
                    if ($scope.data.parentGroupid != null) {
                        params.methodname = 'enableGroupUser';
                        params.GroupId = $scope.data.parentGroupid;
                    }

                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                        modalDialog.alertType('用户启用成功', '', 'success', false, function () {
                            // initUserStatusSelected();                        
                            requestData().then(function () {
                                $scope.data.totalCounts = angular.copy($scope.page.ITEMCOUNT);
                            });
                        });
                    }, function () {
                        requestData().then(function () {
                            $scope.data.totalCounts = angular.copy($scope.page.ITEMCOUNT);
                        });
                    });
                });
            };

            /**
             * [recoveryUser description]恢复用户
             *
             * @return  {[type]}   [return description]
             */
            $scope.recoveryUser = function () {
                var alertContent = '确认还原?';

                modalDialog.confirmModal('恢复用户', alertContent, function () {
                    var params = {
                        serviceid: 'mlf_usermanagement',
                        methodname: 'noAssignedRestoreUser', // 未分配恢复用户
                        UserIds: trsspliceString.spliceString($scope.data.selectedArray, 'USERID', ',')
                    };
                    // 已删除恢复用户
                    if ($scope.data.currStatus != null) {
                        params.methodname = 'clearcRestoreUser';
                    }
                    // 恢复组织用户
                    if ($scope.data.parentGroupid != null) {
                        params.methodname = 'restoreGroupUser';
                        params.GroupId = $scope.data.parentGroupid;
                    }

                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                        modalDialog.alertType('用户恢复成功', '', 'success', false, function () {
                            // initUserStatusSelected();                       
                            requestData().then(function () {
                                $scope.data.totalCounts = angular.copy($scope.page.ITEMCOUNT);
                            });
                        });
                    }, function () {
                        requestData().then(function () {
                            $scope.data.totalCounts = angular.copy($scope.page.ITEMCOUNT);
                        });
                    });
                });
            };

            /**
             * [importUser description]导入用户
             *
             * @return  {[type]}   [return description]
             */
            $scope.importUser = function () {
                if ($scope.data.parentGroupid == null) {
                    importUsers();
                } else {
                    importGroupUsers();
                }
            };

            /**
             * [downloadTemp description]导入用户前下载模板
             *
             * @param  {[type]}  $event   [$event description]
             *
             * @return  {[type]}   [return description]
             */
            $scope.downloadTemp = function ($event) {
                window.open(trsHttpService.getWCMRootUrl() + '?serviceid=mlf_usermanagement' + '&methodname=downLoadUserTemps');
                window.event ? window.event.cancelBubble = true : event.stopPropagation();
            };

            /**
             * [importUsers description]导入用户
             * @return {[type]} [description]
             */
            function importUsers() {
                userManageMentService.importUsers('导入用户', '', function (data) {
                    $scope.loadingPromise = requestData();
                });
            }

            /**
             * [importUsers description]导入组织用户
             * @return {[type]} [description]
             */
            function importGroupUsers() {
                userManageMentService.importUsers('导入用户', $scope.data.parentGroupid, function (data) {
                    $scope.loadingPromise = requestData();
                });
            }

            /**
             * [solutionUser description] 结绑用户
             *
             * @return  {[type]}   [return description]
             */
            $scope.solutionUser = function() {
                modalDialog.alertType('确定解绑选中的用户？', '', 'ask', true, function () {
                    const params = {
                        serviceid: 'mlf_usermanagement',
                        methodname: 'cancelBindUsers',
                        UserIds: trsspliceString.spliceString($scope.data.selectedArray, 'USERID', ',')
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                        modalDialog.alertType('用户解绑成功', '', 'success', false);
                        $scope.loadingPromise = requestData();
                    });
                });
            };

            /**
             * [userNameSearch description;检索:根据用户真实姓名模糊查询用户列表(全文检索)]
             * @param  {[type]} ev [description:按下空格也能提交]
             * @return {[type]} [description]
             */
            $scope.userNameSearch = function (ev) {
                if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                    // getUsersList();
                    requestData();
                }
            };

            /**
             * [sortUser description]列表排序（设置位置）
             *
             * @param  {[type]}  item   [item description]
             * @param  {[type]}  index   [index description]
             *
             * @return  {[type]}   [return description]
             */
            $scope.sortUser = function (item, index) {

                var curPosition = ($scope.page.CURRPAGE - 1) * $scope.page.PAGESIZE + index + 1;
                userManageMentService.sortUsers('调整顺序', item, $scope.data.totalCounts, $scope.status.searchStatusSelected.value, function (data) {
                    $scope.queryByDropdown('name', $scope.status.searchStatusSelected);
                    // requestData();
                    modalDialog.alertType('', '调整顺序成功', 'success', false, function () { });
                }, curPosition);
            };

            /**
             * [showUserDetail description]查看用户详细信息
             *
             * @param  {[type]}  item   [item description]
             *
             * @return  {[type]}   [return description]
             */
            $scope.showUserDetail = function (item) {
                userManageMentService.showUserDetail('用户详细信息', item.USERID, function (data) { });
            };

            $scope.goGroupState = function () {
                $state.go('manageconfig.groupmanage.group', { groupid: $scope.data.parentGroupid }, { reload: 'manageconfig.groupmanage.group' });
            };

            /**
             * [dragoverCallback description]允许拖拽
             *
             * @param  {[type]}  event   [event description]
             * @param  {[type]}  index   [index description]
             * @param  {[type]}  external   [external description]
             * @param  {[type]}  type   [type description]
             *
             * @return  {[type]}   [return description]
             */
            $scope.dragoverCallback = function (event, index, external, type) {
                return true;
            };

            /**
             * [dragStart description]拖拽开始
             *
             * @param  {[type]}  event   [event description]
             * @param  {[type]}  item   [item description]
             * @param  {[type]}  index   [index description]
             *
             * @return  {[type]}   [return description]
             */
            $scope.dragStart = function (event, item, index) {
                $scope.status.dragStartIndex = index;
            };

            /**
             * [dropCallback description]拖拽结束
             *
             * @param  {[type]}  event   [event description]
             * @param  {[type]}  index   [index description]
             * @param  {[type]}  item   [item description]
             * @param  {[type]}  external   [external description]
             * @param  {[type]}  type   [type description]
             * @param  {[type]}  allowedType   [allowedType description]
             *
             * @return  {[type]}   [return description]
             */
            $scope.dropCallback = function (event, index, item, external, type, allowedType) {
                if ($scope.status.dragStartIndex == index) {return;}
                var params = {
                    serviceid: 'mlf_usermanagement',
                    methodname: 'newSortPositionUser',
                    GroupId: $scope.data.currGroup.GROUPID,
                    FromUserId: $scope.users[$scope.status.dragStartIndex].USERID,
                    ToUserId: $scope.status.dragStartIndex > index ? $scope.users[index].USERID : $scope.users[index - 1].USERID,
                    Position: $scope.status.dragStartIndex > index ? 1 : 0,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function () {
                    $timeout(function () {
                        $scope.users.splice($scope.status.dragStartIndex, 1);
                        if ($scope.status.dragStartIndex > index) {$scope.users.splice(index, 0, item);} else {$scope.users.splice(index - 1, 0, item);}
                        // requestData();
                        // $scope.queryByDropdown('name', $scope.status.searchStatusSelected);
                    });
                });
            };


            /**
             * [getUserRoles description]description根据用户id获取用户所属角色信息
             *
             * @param  {[type]}  item   [item description]
             *
             * @return  {[type]}   [return description]
             */
            $scope.getUserRoles = function (item) {
                var params = {
                    'serviceid': 'mlf_usermanagement',
                    'methodname': 'queryUserRoles',
                    'UserId': item.USERID
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    if (angular.isDefined(data)) {
                        item.USERROLES = data;
                        var rolesArr = [];
                        for (var i = 0; i < item.USERROLES.length; i++) {
                            rolesArr[i] = item.USERROLES[i].ROLENAME;
                        }
                        item.USERROLES = rolesArr.join(',');
                        item.subUSERROLES = item.USERROLES.substring(0, 6);
                    }
                });

            };

            /**
             * [initDropDownList description]初始化下拉菜单
             *
             * @return  {[type]}   [return description]
             */
            function initDropDownList() {

                // //选中第一个 copy复刻
                // $scope.status.selectedSearchType = angular.copy($scope.status.searchType[0]);
                // getTenantType().then(function(data) {
                //     $scope.status.tenantType = data;
                //     $scope.status.selectedTenantType = angular.copy($scope.status.tenantType[0]);
                // });
            }

            /**
             * [showModal description]
             *
             * @param  {[type]}  id   [id description]
             *
             * @return  {[type]}   [return description]
             */
            $scope.showModal = function (id) {
                userManageMentService.showUserRole(id);
            };

        }
    ]);
